import { render, staticRenderFns } from "./JobBenefits.vue?vue&type=template&id=6a891b7e&scoped=true"
import script from "./JobBenefits.vue?vue&type=script&lang=js"
export * from "./JobBenefits.vue?vue&type=script&lang=js"
import style0 from "./JobBenefits.vue?vue&type=style&index=0&id=6a891b7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a891b7e",
  null
  
)

export default component.exports